import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";
import { z } from "zod";
import SubscriptionsStatusPage from "@/components/settings/billing/subscriptions-status-page";

const searchSchema = z.object({
	// `delete`: arrived from the workspace delete card, shows a way back.
	from: z.literal("delete").optional().catch(undefined),
});

const WorkspaceSubscriptionsPage = (): JSX.Element => {
	const { from } = Route.useSearch();
	return <SubscriptionsStatusPage fromDeletion={from === "delete"} />;
};

export const Route = createFileRoute("/_app/settings/workspace/subscriptions/")({
	validateSearch: searchSchema,
	component: WorkspaceSubscriptionsPage,
});
